import { createStore, applyMiddleware } from 'redux'
import { createBrowserHistory } from 'history'
import { composeWithDevTools } from 'redux-devtools-extension'
import { routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'
import { createMigrate, persistStore, persistReducer } from 'redux-persist'
import createFilter from 'redux-persist-transform-filter'
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2'
import storage from 'redux-persist/lib/storage'
import createRootReducer from './reducers'
import { screenResize } from './actions/ui'

const history = createBrowserHistory()
const rootReducer = createRootReducer(history)

const filterCriteria = createFilter('filter', [
  'filterCriteria.filter',
  'filterCriteria.sortBy',
  'filterCriteria.heroSize',
  'filterCriteria.limitResults',
  'filterCriteria.geometry'
])
const selectedProperties = createFilter('search', ['selectedProperties'])
const user = createFilter('user', ['armlsLogonType', 'viewedAgentSelector'])
const customPE = createFilter('customPropEval', [
  'subjectProperty',
  'searchBoxText',
  'subjectPropertySearchBoxText',
  'avms'
])

const mapViewBounds = createFilter('map', ['viewBounds'])

const migrations = {
  0: state => ({
    ...state
  }),
  1: state => {
    const updatedFilterCriteria =
      state.filter.filterCriteria.filter.dwellingTypeIds.filter(d => d !== 99)

    return {
      ...state,
      filter: {
        ...state.filter,
        filterCriteria: {
          ...state.filter.filterCriteria,
          filter: {
            ...state.filter.filterCriteria.filter,
            dwellingTypeIds: updatedFilterCriteria
          }
        }
      }
    }
  },
  2: state => {
    const { context, ...rest } = state
    return rest
  }
}

const persistConfig = {
  key: 'root',
  version: 2,
  storage,
  whitelist: [
    'filter',
    'search',
    'user',
    'propEval',
    'customPropEval',
    'compare',
    'share',
    'map'
  ],
  transforms: [
    filterCriteria,
    selectedProperties,
    user,
    customPE,
    mapViewBounds
  ],
  stateReconciler: autoMergeLevel2,
  migrate: createMigrate(migrations, { debug: true })
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(applyMiddleware(routerMiddleware(history), thunk))
)

// if (module.hot) {
//   module.hot.accept('./reducers', () => {
//     store.replaceReducer(createRootReducer(history))
//   })
// }

window.addEventListener('resize', () => {
  const { innerWidth, innerHeight } = window
  store.dispatch(screenResize({ width: innerWidth, height: innerHeight }))
})

const persistor = persistStore(store)

export { history, store, persistor }
